import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./lang"; // Internationalization
import "./permission";
import "./bootstrap";
import "./assets/scss/main.scss";
import "./assets/fonts/cairo/stylesheet.css";
import cookie from "js-cookie";
Vue.config.productionTip = false;
Vue.prototype.locale = cookie.get("language") || "en";

new Vue({
  router,
  store,
  vuetify,
  i18n,
  created() {
    if (!cookie.get("language")) {
      cookie.set("language", "en");
    }
  },
  render: (h) => h(App),
}).$mount("#app");
